import React from 'react'
import PropTypes from 'prop-types'

const Container = (props) => {
    const { className = '' } = props
    return (
        <div className={'container ' + className}>
            {props.children}
        </div>
    )
}

Container.propTypes = {
    className: PropTypes.string,
}

export default Container




// WEBPACK FOOTER //
// ./src/modules/bootstrap/component/Container.js